<div class="form-inline">
{{#COMPARE pageCount '>' 1}}
      <span class="js-select-current-page">
            <button id="ct-prev-page" class="btn-white pagination-btn {{#COMPARE currentPage '==' 1}}disabled{{/COMPARE}}"
            title="{{TR "Vorherige Seite"}}">
                  <i class="fa fa-caret-left"></i>
            </button>
            {{TR "Seite"}}
                  <span class="picker-pagination">
                        <button id="ct-select-page" class="btn-white pagination-btn js-pagination-select">
                              {{currentPage}} <i class="fa fa-caret-down"></i>
                        </button>
                        <span class="picker-pagination-options">
                              <ul>
                                    {{#REPEAT 1 pageCount}}
                                    <li><a data-value="{{i}}">{{i}}</a></li>
                                    {{/REPEAT}}
                              </ul>
                        </span>
                  </span>
             {{TR "von"}} <span id="ct-page-count">{{pageCount}}</span>
            <button id="ct-next-page" class="btn-white pagination-btn next {{#COMPARE currentPage '==' pageCount}}disabled{{/COMPARE}}"
            title="{{TR "Nächste Seite"}}">
                  <i class="fa fa-caret-right"></i>
            </button>
      </span>
{{/COMPARE}}
{{#COMPARE totalCount '>' 10}}
      <span class="js-select-items-per-page">
            <span class="picker-pagination">
                  <button id="ct-entries-per-page" class="btn-white pagination-btn js-pagination-select">
                        {{#COMPARE itemsPerPage '==' -1}}{{TR "alle"}}{{else}}{{itemsPerPage}}{{/COMPARE}}
                        <i class="fa fa-caret-down"></i>
                  </button>
                  <span class="picker-pagination-options">
                        <ul>
                              <li><a data-value="10">10</a></li>
                              <li><a data-value="20">20</a></li>
                              <li><a data-value="50">50</a></li>
                              <li><a data-value="100">100</a></li>
                        </ul>
                  </span>
                  {{TR "Einträge pro Seite"}}
            </span>
      </span>
{{/COMPARE}}
</div>
